<style>
.holder {
    border-radius: 10px;
    border: 1px solid #ccc;
    margin: 0 0 0.5em 0;
    margin-top: 5px;
    padding: 10px;
}

button {
    background-color: white;
    border: 1px solid rgb(223, 223, 223);
    color: grey;
}
</style>

<script>
    export let options

    function addOption() {
        options = options.concat('')
    }

    function removeOption(option) {
        options = options.filter(o => o != option)
    }

</script>

<div class="holder">
    {#each options as option}
        <div class="option">
            <input style="width:80%" bind:value={option}> <button on:click={removeOption(option)}>Remove</button>
        </div>
    {/each}
    <div class="add-holder">
        <button on:click={addOption}>Add option</button>
    </div>
</div>
